module.exports = __webpack_public_path__ + "img/9c5b2ea.png";